import React from "react";
import {
  FaInstagram, FaTiktok, FaTelegram, FaFacebook,
  FaDiscord, FaTwitter, FaLinkedin, FaGlobe,FaHeadset, FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { motion } from "framer-motion";
import Logo from "./logo";
import { useSocial } from "../hooks/useSocial";




// console.log(telegram)

const iconMap = {
  instagram: <FaInstagram />,
  facebook: <FaFacebook />,
  tiktok: <FaTiktok />,
  twitter: <FaXTwitter />,
  telegram: <FaTelegram />,
  discord: <FaDiscord />,
  linkedin: <FaLinkedin />,
  admin:<FaHeadset/>,
  youtube:<FaYoutube/>,
  x: <FaXTwitter />,
  default: <FaGlobe />,
};

const quickLinks = [
  { text: "Home", href: "/" },
  { text: "About Us", href: "#about" },
  { text: "Reviews", href: "#reviews" },
  // { text: "Pricing", href: "#pricing" },
  { text: "FAQ", href: "#faq" },
  { text: "Contact", href: "#contact" },
];

const platforms = ["MetaTrader 4", "MetaTrader 5", "TradeLocker", "cTrader", "DXTrade", "MatchTrader"];

export default function Footer() {
  const { socials, loading, error } = useSocial();
  console.log(socials)
 
const telegram = socials.find((i) => i.label?.toLowerCase() === "telegram");
const admin = socials.find((i) => i.label?.toLowerCase() === "admin");

  return (
    <footer className="relative overflow-hidden" style={{ background: "#020710" }}>
      {/* Top accent */}
      <div className="w-full h-px" style={{ background: "linear-gradient(90deg, transparent, #22c55e 30%, #3b82f6 70%, transparent)" }} />

      {/* Background grid */}
      <div className="absolute inset-0 grid-bg opacity-20" />

      {/* Glow orbs */}
      <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full blur-3xl opacity-5 pointer-events-none" style={{ background: "#22c55e" }} />
      <div className="absolute top-0 right-0 w-72 h-72 rounded-full blur-3xl opacity-5 pointer-events-none" style={{ background: "#3b82f6" }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">

          {/* Brand column */}
          <div className="lg:col-span-1">
            <Logo />
            <p className="text-slate-400 text-sm leading-relaxed mt-4 mb-6">
              Professional algorithmic trading software trusted by thousands of traders worldwide. Automate your trading. Amplify your profits.
            </p>
            {/* Social links */}
            <div className="flex flex-wrap gap-3">
              {loading && <span className="text-slate-500 text-xs">Loading...</span>}
              {!loading && !error && socials.filter((s) => s.status === "active").map((item) => {
                const labelKey = item.label?.toLowerCase();
                const Icon = iconMap[labelKey] || iconMap.default;
                return (
                  <motion.a
                    key={item._id}
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    whileHover={{ scale: 1.2, y: -3 }}
                    whileTap={{ scale: 0.9 }}
                    className="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-white transition-colors"
                    style={{ background: "rgba(59,130,246,0.08)", border: "1px solid rgba(59,130,246,0.15)" }}
                    title={item.label}
                  >
                    {Icon}
                  </motion.a>
                );
              })}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-orbitron text-white text-sm font-bold tracking-widest uppercase mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link, i) => (
                <motion.li key={i} whileHover={{ x: 4 }}>
                  <a href={link.href} className="text-slate-400 hover:text-green-400 text-sm transition-colors flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-green-500 opacity-60" />
                    {link.text}
                  </a>
                </motion.li>
              ))}
            </ul>
          </div>

          {/* Platforms */}
          <div>
            <h4 className="font-orbitron text-white text-sm font-bold tracking-widest uppercase mb-6">
              Supported Platforms
            </h4>
            <ul className="space-y-3">
              {platforms.map((p, i) => (
                <li key={i} className="flex items-center gap-2 text-slate-400 text-sm">
                  <span className="text-green-400">✓</span>
                  {p}
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter / CTA */}
          <div>
            <h4 className="font-orbitron text-white text-sm font-bold tracking-widest uppercase mb-6">
              Get Started Today
            </h4>
            <p className="text-slate-400 text-sm mb-6">
              Join thousands of profitable traders using UEA Trading Software.
            </p>
            <motion.a
              href={telegram?.url||'#'}
              whileHover={{ scale: 1.04, boxShadow: "0 0 30px rgba(34,197,94,0.4)" }}
              whileTap={{ scale: 0.97 }}
              className="block text-center font-orbitron text-xs tracking-widest uppercase font-bold py-3.5 px-6 rounded-xl text-white mb-3"
              style={{ background: "linear-gradient(135deg, #22c55e, #3b82f6)" }}
            >
            <span className="flex gap-2 space-x-1 items-center text-center justify-center">< FaTelegram size={24}/>
            <p>Join Telegram</p></span> 
            </motion.a>
            <motion.a
              href={admin?.url||'#'}
              whileHover={{ scale: 1.04 }}
              className="block text-center font-orbitron text-xs tracking-widest uppercase font-bold py-3.5 px-6 rounded-xl border text-slate-300 hover:text-white transition-colors"
              style={{ borderColor: "rgba(59,130,246,0.3)", background: "rgba(59,130,246,0.05)" }}
            >
               <span className="flex gap-2 space-x-1 items-center text-center justify-center">< FaHeadset size={24}/>
               <p>Contact Admin</p></span> 
              
            </motion.a>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px my-8" style={{ background: "linear-gradient(90deg, transparent, rgba(59,130,246,0.3), transparent)" }} />

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-xs text-center sm:text-left">
            © {new Date().getFullYear()}{" "}
            <span className="text-green-400 font-semibold font-orbitron">UEA Trading Software</span>
            {" "}— All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-xs text-slate-500">
            <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" />
            <span className="font-mono-code">Systems operational</span>
          </div>
          <p className="text-slate-600 text-xs">
            Trading involves risk. Past performance ≠ future results.
          </p>
        </div>
      </div>
    </footer>
  );
}
